import React from 'react'

function SamsungPay() {
  return (
    <div class="idocs-content">
      <div class="container">
        <div class="row">
          <div class="col-md-8">
            <section id="idocs_content" class="mt-20 mb-20">
              <h1>Samsung Pay</h1>
              <hr />
            </section>



          
          </div>
          <div class="col-md-4"></div>
        </div>
      </div>
    </div>
  )
}

export default SamsungPay;